import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';
import { Button } from '../button';

const Option = memo(({ item, onSelect }) => {
  return (
    <div
      key={item.value}
      role="button"
      className={onSelect ? 'Options__Item Options__Item--clickable' : 'Options__Item'}
      onClick={onSelect ? () => onSelect(item.value) : undefined}
    >
      {item.icon ? <div className="Options__Item__Icon"><Icon type={item.icon} /></div> : null}
      <div>
        <div className="Options__Item__Title">{item.title}</div>
        {item.description ? <small>{item.description}</small> : null}
        {item.action ? (
          <Button
            size="small"
            type="inverted-primary"
            onClick={item.action.onClick}
          >
            {item.action.title}
          </Button>
        ) : null}
      </div>
    </div>
  );
});

const Options = ({ items, containerClassName, onSelect }) => (
  <div
    className={containerClassName ? `Options ${containerClassName}` : 'Options'}
  >
    { items.map((item) => <Option item={item} onSelect={onSelect} />) }
  </div>
);

Options.propTypes = {
  items: PropTypes.array.isRequired,
  containerClassName: PropTypes.string,
  onSelect: PropTypes.func,
};

export default Options;
